<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
.pdf-export {
  .markdown-body h1 {
    margin-top: 0 !important;
  }
}
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5" style="align-items:center;">
        <span style="white-space:nowrap;">选择人员</span>
        <Select v-model="uid" style="width:160px;" placeholder="选择人员" filterable @on-change="getData()">
          <Option v-for="p in users" :key="p.key" :value="p.key">{{ p.name }}</Option>
        </Select>
        <template v-if="person_projects.length > 1">
          <span style="white-space:nowrap;">选择项目({{ person_projects.length }})</span>
          <Select v-model="selected_projects" multiple filterable placeholder="选择项目" @on-change="filterData()">
            <Option v-for="p in person_projects" :key="p" :value="p">{{ p }}</Option>
          </Select>
        </template>
      </div>
      <div class="zzl-view-top-actions flex-wrap">
        <Button class="zzl-view-top-refresh" type="default" @click="getUsers">刷新列表</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="loading" fix size="large">
          <div class="zzl-view-data-loading-text">加载数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">数据下载和清理</div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" icon="md-download" :disabled="!uid" :loading="loading" @click="getData">获取数据</Button>
              <Button type="warning" @click="CopyToClip">复制数据</Button>
            </div>
          </div>
          <div class="zzl-view-left-toolbar" style="margin-bottom:8px;flex-shrink:0;">
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;">
              <i-switch v-model="onlySelf" size="small" @on-change="filterData" />
              <span style="font-size:12px;">只展示本人工作</span>
              <i-switch v-model="extractForm" size="small" @on-change="filterData" />
              <span style="font-size:12px;">提取表格</span>
              <i-switch v-model="onlyQuestion" size="small" @on-change="filterData" />
              <span style="font-size:12px;">隐藏合规项</span>
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
            </div>
          </div>
          <div class="zzl-view-left-track flex-wrap split5" style="margin-bottom:8px;align-items:center;flex-wrap:wrap;gap:8px;flex-shrink:0;">
            <span style="font-size:12px;color:#64748b;">跟踪记录</span>
            <BaseDate v-model="tracking_startDate" placeholder="开始日期" />
            <BaseDate v-model="tracking_endDate" placeholder="结束日期" />
            <Button size="small" @click="prevWeek">上一周</Button>
            <Button size="small" @click="nextWeek">下一周</Button>
            <Button size="small" @click="filterData">按范围刷新</Button>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="4"
              style="width:100%;flex:1;min-height:0;"
              placeholder="获取数据后显示清洗结果。"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="zzl-person"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('zzl-person') }} · zzl-person）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button v-if="images.length" @click="copyImageAddresses">复制图片地址</Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
            <AiSaveToKnowledgeButton :content="result" :disabled="!result || ai_executings" :file-name="zzlSaveFileName" />
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import { extractAttachments, deepCleanTask, renderEFormMap } from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';
import { buildZzlPdfFileStem } from '@/components/ai/zzl/zzl-report-filename';

export default {
  components: { AiPromptPanel, AiMarkdownStreamPanel },
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateKey: 'ai_zzl_person',
      pageStateFields: ['uid', 'selected_projects', 'onlySelf', 'extractForm', 'onlyQuestion', 'tracking_startDate', 'tracking_endDate', 'userText'],
      aiText: '',
      uid: 'wangqw8001',
      loading: false,
      users: [],
      extractForm: false,
      onlyQuestion: false,
      images: [],
      files: [],
      userText: '',
      onlySelf: false,
      tracking_startDate: moment().startOf('week').subtract(1, 'week').format('YYYY/MM/DD'),
      tracking_endDate: moment().endOf('week').subtract(1, 'week').format('YYYY/MM/DD'),
      ai_executings: false,
      result: '',
      tasks: [],
      person_projects: [],
      selected_projects: [],
      projects: [],
      project_id: 'pid65054f01eabec',
      view: 'recent',
    };
  },

  mounted() {
    this.$api.afterLogin(() => {
      this.getUsers();
    });
  },
  methods: {
    labelForMod,
    zzlReportPdfStem() {
      const u = this.users.find((x) => x.key === this.uid);
      const range = `${moment(this.tracking_startDate).format('YYYYMMDD')}-${moment(this.tracking_endDate).format('YYYYMMDD')}`;
      return buildZzlPdfFileStem(['岗位数据', u && u.name, range]);
    },
    getData() {
      this.loading = true;
      this.$api.post('logined_zzl/get_tracking_data', {
        uid: this.uid,
        started_at: this.tracking_startDate,
        ended_at: this.tracking_endDate,
      }).then((res) => {
        this.tasks = res.data.data;
        this.filterData();
      }).catch((e) => {
        console.error(e);
        this.Error(e && e.message ? e.message : '获取数据失败');
      }).finally(() => {
        this.loading = false;
      });
    },
    filterData() {
      this.__savePageState();
      const tasks = this.tasks;
      const groupmap = {};
      tasks.forEach((t) => {
        if (!t.projectName) {
          return;
        }
        if (groupmap[t.projectName]) {
          groupmap[t.projectName].push(t);
        } else {
          groupmap[t.projectName] = [t];
        }
      });
      let result = '';
      const eformmap = {};
      this.person_projects = Object.keys(groupmap);
      let projects = this.person_projects;
      if (this.selected_projects.length > 0) {
        projects = projects.filter((p) => this.selected_projects.includes(p));
      }
      projects.forEach((p) => {
        result += '======== 项目名称:' + p + '========\n';
        groupmap[p].forEach((t) => {
          result += deepCleanTask(t, this.tracking_startDate, this.tracking_endDate, this.onlySelf ? this.uid : null, this.extractForm ? eformmap : null, this.onlyQuestion) + '\n';
        });
      });

      const formstrs = renderEFormMap(eformmap);

      this.aiText = result;
      const user = this.users.find((u) => u.key == this.uid);
      this.userText = `以下是[${user ? user.name : ''}]一周的工作任务数据，请进行统计、分析和简要评价后，生成工作周报[${moment(this.tracking_startDate).format('YYYY/MM/DD')}]-[${moment(this.tracking_endDate).format('YYYY/MM/DD')}]。工作周报内容分为三部分，第一部分是工作统计分析；第二部分是工作记录关键数据分析，这部分需列表展示；第三部分是工作任务执行评价。注意如果任务包含多项目/事业部的数据，注意区分;${this.onlyQuestion ? '注意检查表提供的数据的合规项已隐藏，只显示异常项目' : ''}`;
      this.aiText = formstrs + '\n' + this.aiText;
      const { images, files, text } = extractAttachments(this.aiText);
      this.images = images;
      this.files = files;
      this.aiText = text;
    },
    prevWeek() {
      this.tracking_startDate = moment(this.tracking_startDate).startOf('week').subtract(1, 'week').format('YYYY/MM/DD');
      this.tracking_endDate = moment(this.tracking_startDate).endOf('week').format('YYYY/MM/DD');
      this.getData();
    },
    nextWeek() {
      this.tracking_startDate = moment(this.tracking_startDate).startOf('week').add(1, 'week').format('YYYY/MM/DD');
      this.tracking_endDate = moment(this.tracking_startDate).endOf('week').format('YYYY/MM/DD');
      this.getData();
    },
    getUsers() {
      this.$api.get('logined_zzl/users').then((res) => {
        this.users = res.data.data;
      });
    },
    async CopyToClip() {
      const text = this.aiText || '';
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          const successful = document.execCommand('copy');
          if (!successful) {
            throw new Error('复制失败');
          }
          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        return false;
      }
    },
  },
};
</script>
